import { Injectable, inject } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DateFormatService {
  private readonly datePipe = inject(DatePipe);

  formatDate(date: Date) {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }
}
